export const NavData = ["About ", "Experience ", "Projects ", "Contact "];
export const ExpData = [
  {
    id: 0,

    name: "Fibo",
    role: ["Frontend Developer", "August 2023 - October 2023"],
    summary: [
      "Created new pages, components and features from scratch, significantly enhancing the user experience.",
      "Collaborated on User Side Application, conducted unit testing & ensured it aligns with the feature requirements.",
    ],
    gradient: "one",
    skillsUsed: [
      {
        text: "NextJS",
        link: "google.com",
      },
      {
        text: "ReactJS",
        link: "google.com",
      },
      {
        text: "SCSS",
        link: "google.com",
      },
    ],
  },

  {
    id: 1,
    name: "Bhaukaal Studios",
    role: ["Web Developer", "July 2023 - August 2023"],
    summary: [
      "Designed CMS using Contentful API for blog management & contributed to various client projects as per design",
      "Implemented responsive design, creating dynamic web applications and provided insights on user experience on various projects.",
    ],
    gradient: "two",
    skillsUsed: [
      {
        text: "Javascript",
        link: "google.com",
      },
      {
        text: "CSS",
        link: "google.com",
      },
      {
        text: "GSAP",
        link: "google.com",
      },
    ],
  },
  {
    id: 2,
    name: "E-Cell",
    role: ["Tech Member", "January 2022 - Present"],
    summary: [
      "Led the successful revamp of the E-cell Website, implementing design enhancements and optimizing user experience.",
      "Successfully engage in meetings, hackathons and sponsor collaborations for growth and innovation.",
    ],
    gradient: "three",
    skillsUsed: [
      {
        text: "Javascript",
        link: "google.com",
      },
      {
        text: "CSS",
        link: "google.com",
      },
    ],
  },
];

export const ProjectData = [
  {
    id: "01.",
    projName: "Muse",
    Description:
      " Muse is the ultimate music streaming app that not only lets you enjoy your favorite songs but also allows you to create and share your playlists with friends and listen to them in real time with them.",
    image: "./Muse.jpg",
    skills: ["ReactJS", "Firebase", "JavaScript"],
    github: "https://github.com/kanikarajpal/Muse",
    site: "https://themuse.netlify.app/",
    projColor: "one",
  },
  {
    id: "02.",
    projName: "Fare-o-cab",
    Description:
      "An app that could predict the approximate cab fare for your ride on different platforms and gives the best option available to you with 85% accuracy.",
    image: "./Fare-o-Cab.jpg",
    skills: ["Scikit", "HTML", "JavaScript"],
    github: "https://github.com/kanikarajpal/fare-o-cab",
    site: "https://fare-o-cab.herokuapp.com/",
    projColor: "two",
  },
  {
    id: "03.",
    projName: "Virtual Piano",
    Description:
      "The ultimate virtual piano that anyone can play and become an online pianist.It lets you play a piano online, by using mouse or keyboard with any device.",
    image: "./VirtualPiano.jpg",
    skills: ["CSS", "JavaScript"],
    github: "https://github.com/kanikarajpal/Virtual-Piano",
    site: "https://kanikarajpal.github.io/Virtual-Piano/",
    projColor: "three",
  },
  {
    id: "04.",
    projName: "Rock Paper Scissors",
    Description:
      "A very interesting and interactive Rock-Paper-Scissors game that gives flashbacks of childhood, designed using figma.",
    image: "./RockPaperScissors.jpg",
    skills: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/kanikarajpal/Rock-paper-scissors",
    site: "https://kanikarajpal.github.io/Rock-paper-scissors/",
    projColor: "four",
  },

  {
    id: "05.",
    projName: "Beauty Care",
    Description:
      "Beauty Care is an e-commerce website where you can purchase any makeup product.It has beautiful front-end built with HTML and CSS and designed with figma. ",
    image: "./BeautyCare.jpg",
    skills: ["HTML", "CSS"],
    github: "https://github.com/kanikarajpal/Beauty-Care",
    site: "https://kanikarajpal.github.io/Beauty-Care/",
    projColor: "five",
  },
];
